export class ColorConf {
  static readonly Primary = "#16212c";
  static readonly Secondary = "#f50";
  static readonly Tertiary = "#BAD3FF";
  static readonly PrimaryForWomen = "#FF999E";
  static readonly SecondaryForWomen = "#fe6970";
  static readonly TertiaryForWomen = "#CBA8D8";
  static readonly Premium = "#FFD700";
  static readonly BaseText = "#555";
  static readonly DeepGreyText = "#00000099";
  static readonly PrimaryText = "#7b7693";
  static readonly MainText = "#000000DE";
  static readonly BackGroundLightGrey = "#eee";
  static readonly White = "#fff";
  static readonly Active = "#37b507";
  static readonly SecondActive = "#F8B62D";
  static readonly BorderLightGrey = "#fefefe";
  static readonly TextDeepGrey = "#615e5e";
  static readonly TextLightGrey = "#8e8e8e";
  static readonly BalloonBackgroundOrange = "#ff9c6b";
  static readonly BlockBackgroundRed = "#d70e00";
  static readonly Twitter = "#000000";
  static readonly DeleteRed = "#fa3d50ec";
  static readonly LightPink = "#ffe6e6";
  static readonly Pink = "#ffcccc";
  static readonly Gold = "#ffd700";
  static readonly MonoPrimaryText = "rgba(85, 85, 85, 1)";
  static readonly MonoAlternate = "rgba(170, 170, 170, 1)";
  static readonly Accent = "#4790F7";
  static readonly Error100 = "rgba(251, 56, 77, 1)";
  static readonly Primary25 = "rgba(255, 153, 158, 0.25)";
  static readonly MonoSecondaryText = "rgba(128, 128, 128, 1)";
  static readonly Warning100 = "rgba(233, 171, 37, 1)";
  static readonly Warning5 = "rgba(233, 171, 37, 0.05)";
  static readonly Info = "#2C5EE8";
  static readonly MonoBorder = "rgba(230, 230, 230, 1)";
  static readonly MonoButton = "rgba(255, 255, 255, 1)";
  static readonly Accent100 = "rgba(254, 105, 112, 1)";
  static readonly Accent25 = "rgba(254, 105, 112, 0.25)";
  static readonly Accent15 = "rgba(254, 105, 112, 0.1)";
  static readonly Success100 = "rgba(23, 180, 114, 1)";
  static readonly HeroPrimaryColor = "#eb6363";
  static readonly HeroPrimaryText = "#030303";
  static readonly HeroSecondaryText = "#747474";
  static readonly HeroTertiaryText = "#626262";
  static readonly HeroTitleTextShadow =
    "1px 1px 0 #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 0px 1px 0 #fff, 1px 0px 0 #fff, 0px -1px 0 #fff, -1px 0px 0 #fff";
  static readonly Primary100 = "rgba(255, 153, 158, 1)";
  static readonly MonoSecondaryBackground = "rgba(250, 250, 250, 1)";
  static readonly Secondary100 = "rgba(203, 168, 216, 1)";
  static readonly Primary15 = "rgba(255, 153, 158, 0.15)";
  static readonly Secondary15 = "rgba(203, 168, 216, 0.15)";
  static readonly Success75 = "rgba(23, 180, 114, 0.75)";
  static readonly Primary5 = "rgba(255, 153, 158, 0.05)";
  static readonly Primary50 = "rgba(255, 153, 158, 0.5)";
}
